import { type Meta } from '../types/docs';

const META: Meta = {
  description: 'Admin revoked the SCIM bearer token, disabling SCIM provisioning',
  name: 'scim_token_revoked',
  params: [
    {
      description: 'Location of the revoke action',
      name: 'location',
      required: true,
      type: 'enum',
      values: ['workspace-settings-security'],
    },
  ],
};

export default META;
